import React, { Component } from 'react';
import { Button, Icon } from 'react-materialize';

import TableGrid from './TableGrid';
import ThumbnailsGrid from './ThumbnailsGrid';
import EventUtils from '../../utils/EventUtils';
import CommonConstants from '../../constants/CommonConstants';

import './Grid.css';

class Grid extends Component {
  static DISPLAY_MODE_TABLE = 0;
  static DISPLAY_MODE_THUMBNAIL_GRID = 1;

  constructor(props) {
    super(props);

    const { displayMode } = props;

    this.state = {
      displayMode: displayMode ? displayMode : Grid.DISPLAY_MODE_TABLE,
      selected: []
    };

    this.displayThumbnailGrid = this.displayThumbnailGrid.bind(this);
    this.displayTable = this.displayTable.bind(this);
    this._handleSelect = this._handleSelect.bind(this);
    this._handleSelectAllClick = this._handleSelectAllClick.bind(this);
    this._handleAddToCartClick = this._handleAddToCartClick.bind(this);
  }

  get selected() {
    return this.state.selected;
  }

  set selected(selected) {
    this.setState({ selected: selected });
  }

  get displayMode() {
    return this.state.displayMode;
  }

  set displayMode(displayMode) {
    this.setState({ displayMode: displayMode });
  }

  displayThumbnailGrid() {
    this.setState({ displayMode: Grid.DISPLAY_MODE_THUMBNAIL_GRID });
  }

  displayTable() {
    this.setState({ displayMode: Grid.DISPLAY_MODE_TABLE });
  }

  _handleSelect(event) {
    let detail = event.detail;

    if (detail.selected) {
      let selected = this.selected;
      if (selected)
        selected.push(detail.id);

        this.selected = selected;
    } else {
        this.selected = this.selected.filter(x => x !== detail.id);
    }
}

  _handleSelectAllClick(event) {
    let selected = [];

    for (let i = 0; i < this.props.entries.length; i++) {
      if (selected.includes(i)) {
        continue;
      }

      selected.push(i);
    }

    this.selected = selected;
  }

  _handleAddToCartClick(event) {
    const { selected } = this.state;
    const { entries } = this.props;

    let entriesToAdd = [];
    for (let i = 0; i < selected.length; i++) {
      let entry = entries[selected[i]];

      if (entry) {
        if(entry.type === CommonConstants.ACTIVE_ASSETS_FILE_TYPE){
          //Adding Source Application to Live Assets
          entry.properties['live_file:sourceApplication'] = 'STAR LABS';
        }
        entriesToAdd.push(entry);
      }
    }

    EventUtils.raiseEvent('add-to-cart', { items: entriesToAdd }, this.props);
  }

  componentWillReceiveProps(props) {
    if (props.entries !== this.props.entries) {
      this.selected = [];
    }
    
    if(props.displayMode !== this.props.displayMode){
        this.displayMode = props.displayMode;
    }
  }

  render() {
    const { displayMode, selected } = this.state;
    const { totalCount, entries, tableColumns, thumbnailMapper, hidden } = this.props;
    
    return (
      <div className="grid" hidden={ hidden }>
        <div className="grid-toolbar">
          <label>{ totalCount } entries found.</label>
          <Button floating className={ displayMode === Grid.DISPLAY_MODE_THUMBNAIL_GRID ? 'grid-btn active' : 'grid-btn' } waves="teal" tooltip="Show as Thumbnails" onClick={ this.displayThumbnailGrid }>
              <Icon tiny>view_module</Icon>
          </Button>
          <Button floating className={ displayMode === Grid.DISPLAY_MODE_TABLE ? 'grid-btn active' : 'grid-btn' } waves="teal" tooltip="Show as Table" onClick={ this.displayTable }>
              <Icon tiny>list_view</Icon>
          </Button>
          <Button floating className="grid-btn" waves="teal" tooltip="Select All" onClick={ this._handleSelectAllClick } style={ entries.length === 0 ? { display: 'none' } : {} }>
              <Icon tiny>select_all</Icon>
          </Button>
          <Button floating className="grid-btn" waves="teal" tooltip="Add To Cart" onClick={ this._handleAddToCartClick } style={ entries.length === 0 || selected.length === 0 ? { display: 'none' } : {} }>
              <Icon tiny>add_shopping_cart</Icon>
          </Button>
        </div>
        <TableGrid 
          columns={ tableColumns } 
          entries={ entries } 
          selected={ selected }
          hidden={ displayMode !== Grid.DISPLAY_MODE_TABLE } 
          onScrollBottom={ this.props.onScrollBottom }
          onSelect={ this._handleSelect } />
        <ThumbnailsGrid 
          thumbnailMapper={ thumbnailMapper }
          entries={ entries } 
          selected={ selected }
          hidden={ displayMode !== Grid.DISPLAY_MODE_THUMBNAIL_GRID } 
          onScrollBottom={ this.props.onScrollBottom } 
          onSelect={ this._handleSelect } />
      </div>
    );
  }
}

export default Grid;